import ProgressBar from './ProgressBar';

const ProgressBarDirective = reactDirective => {
  return reactDirective(ProgressBar, undefined, { restrict: 'E' }, {});
};

ProgressBarDirective.$inject = ['reactDirective'];

export default ProgressBarDirective;
